import { Component, OnInit, OnChanges, Input, Output,
  EventEmitter, ViewChild } from '@angular/core';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-input-autocomplete',
  template: `<div class="inputAutoCompleteContainer {{color}}Input" [class.open]="focus" [class.rdDark]="dark">
  <span class="placeholder" [class.focus]="focus || value !== ''" (click)="changeFocus()">{{placeholder}}</span>
  <input class="input" type="text" #input [ngModel]="value" (ngModelChange)="changeValue($event)"
    (keydown)="pressKey($event)" (focus)="focusInput()" (focusout)="unfocusInput()" [disabled]="disabled">
  <div class="autoCompleteMenu">
    <ng-container *ngFor="let completeValue of getMatchingValues(); let last = last">
      <div class="matchingValue" (click)="clickValue(completeValue)">{{completeValue}}</div>
      <div class="separator" *ngIf="!last"></div>
    </ng-container>
    <ng-container *ngIf="getMatchingValues().length === 0">
      <div>{{noMatchingText}}</div>
    </ng-container>
  </div>
</div>
`,
  styles: [`.inputAutoCompleteContainer{--main-color:#ba9e5a;--text-color:black;--background-color:white;--hover-color:#f1f1f1;position:relative;margin-top:20px;transition:all .3s linear}.inputAutoCompleteContainer .placeholder{position:absolute;transition:all .2s ease-in;z-index:0;color:var(--text-color)}.inputAutoCompleteContainer .placeholder.focus{font-size:12px;-webkit-transform:translateY(-100%);transform:translateY(-100%);color:var(--main-color)}.inputAutoCompleteContainer .input{border:none;border-bottom:1px solid #e3e3e3;width:100%;height:100%;z-index:1;background-color:transparent;color:var(--text-color)}.inputAutoCompleteContainer .input:focus{border-bottom-width:2px;border-bottom-color:var(--main-color);box-shadow:none}.inputAutoCompleteContainer .autoCompleteMenu{position:absolute;top:auto;left:auto;min-width:inherit;width:100%;background-color:var(--background-color);color:var(--text-color);box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);padding:6px;z-index:1;cursor:pointer}.inputAutoCompleteContainer .autoCompleteMenu .matchingValue{padding:6px 3px}.inputAutoCompleteContainer .autoCompleteMenu .matchingValue:hover{background-color:var(--hover-color)}.inputAutoCompleteContainer .autoCompleteMenu .separator{width:100%;height:1px;background-color:#e3e3e3}.inputAutoCompleteContainer:not(.open)>.autoCompleteMenu{display:none}.inputAutoCompleteContainer.blackInput{--main-color:black}.inputAutoCompleteContainer.greenInput{--main-color:#72ba5a}.inputAutoCompleteContainer.blueInput{--main-color:#5a5aba}.inputAutoCompleteContainer.blue-lightInput{--main-color:#5aa2ba}.inputAutoCompleteContainer.redInput{--main-color:#ba5a5a}.inputAutoCompleteContainer.purpleInput{--main-color:#a25aba}.inputAutoCompleteContainer.orangeInput{--main-color:#ba8a5a}.inputAutoCompleteContainer.rdDark{--text-color:white;--background-color:#07384c;--hover-color:#11506a}`]
})
export class RDInputAutocompleteComponent implements OnInit, OnChanges {

  @Input() value = '';
  @Input() placeholder = '';
  @Input() color = 'gold';
  @Input() disabled = false;
  @Input() completeValues: Array<string> = [];
  @Input() noMatchingText = 'No matching value';

  @Output() valueChange = new EventEmitter<any>();
  @Output() pressEnter = new EventEmitter<any>();

  @ViewChild('input') input;

  public focus = false;
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.focus = (this.value === '' || this.value === null) ? false : true;
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngOnChanges(changes) {
    this.focus = (this.value === '' || this.value === null) ? false : true;
  }

  changeFocus() {
    this.input.nativeElement.focus();
  }

  changeValue(event) {
    this.value = event;
    this.valueChange.emit(event);
  }

  pressKey(event) {
    if (event.keyCode === 13) {
      this.pressEnter.emit();
    }
  }

  focusInput() {
    this.focus = true;
  }

  unfocusInput() {
    setTimeout(() => {
      this.focus = false;
    }, 200);
  }

  getMatchingValues() {
    const matching = [], levensthein = [];
    for (const value of this.completeValues) {
      if (value.match(this.value)) {
        matching.push(value);
      } else if (this.levenshteinDistance(this.value, value) <= value.length / 2) {
        levensthein.push(value);
      }
    }
    return matching.concat(levensthein);
  }

  levenshteinDistance (a: string, b: string): number {
    const m = [], min = Math.min;

    if (!(a && b)) {
      return (b || a).length;
    }
    for (let i = 0; i <= b.length; m[i] = [i++]) {}
    for (let j = 0; j <= a.length; m[0][j] = j++) {}

    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
        m[i][j] = m[i - 1][j - 1];
        } else {
        m[i][j] = m[i][j] = min(m[i - 1][j - 1] + 1, min(m[i][j - 1] + 1, m[i - 1 ][j] + 1));
        }
      }
    }
    return m[b.length][a.length];
  }

  clickValue(value) {
    this.value = value;
    this.valueChange.emit(value);
    this.focus = false;
  }
}
